import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import React from "react";
import Payment from "payment";

import PluginToolbar from "./plugin-toolbar";
import PluginFooter from "./plugin-footer";

class PluginBilling extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    getStarted() {
        hashHistory.push("search");
    }

    render() {
        return (
            <span>
                <div className="quick-nav">
                    <PluginToolbar />
                </div>
                <div
                    className="loginView"
                    style={{
                        background: "black",
                        color: "white",
                        padding: "50px 16px 100px",
                        minHeight: "100%"
                    }}
                >
                    <div
                        className="info-container"
                        style={{
                            display: "flex",
                            width: "100%",
                            minWidth: "250px",
                            maxWidth: "600px",
                            margin: "0 auto",
                            flexDirection: "column",
                            textAlign: "center"
                        }}
                    >
                        <i
                            className="ui_pro-accounts plan-pro font-xxlarge"
                            style={{
                                color: "white",
                                margin: "40px 0"
                            }}
                        />
                        <p className="weight-medium font-medium">
                            You now have access to
                        </p>
                        <ul className="weight-light padding-b-xxl">
                            <li className="padding-s">
                                Over a million icons to choose from
                            </li>
                            <li className="padding-s">
                                Unlimited royalty-free icons
                            </li>
                            <li className="padding-s">
                                Access to all{" "}
                                <a
                                    className="text-link color-white"
                                    href="https://thenounproject.com/apps"
                                    onClick={window.handleLink.bind(this)}
                                    style={{ color: "#FFFFFF" }}
                                    target="_blank"
                                >
                                    apps & plugins
                                </a>
                            </li>
                        </ul>
                        <button
                            className="button blue full-width ui_arrow-right-line"
                            onClick={this.getStarted.bind(this)}
                        >
                            <span>Alright!</span>
                        </button>
                        <p>
                            You can also use NounPro on the&nbsp;web.&nbsp;<a
                                href="https://thenounproject.com/pricing/"
                                onClick={window.handleLink.bind(this)}
                                target="_blank"
                                style={{
                                    textDecoration: "underline",
                                    color: "white"
                                }}
                            >
                                learn&nbsp;more
                            </a>
                        </p>
                    </div>
                </div>
                <PluginFooter />
            </span>
        );
    }
}

module.exports = PluginBilling;
